import styled from 'styled-components';

export const SearchField = {
    Container: styled.div`
        margin-top: 20px;
    `,
    Wrapper: styled.div`
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        @media all and (max-width:992px){
            flex-direction: column;
            gap: 10px;
        }

        .box{
            display: flex;
            gap: 10px;
            align-items: center;
            flex:1;
            width: 100%;
        }

        .inputBox{
            position: relative;
            flex:1;
            /* max-width: 300px; */
            input{
            }

            .label{
                position: absolute;
                bottom: 2px;
                right: 10px;
                font-size: 10px;
                color: var(--purpleColor1);
                font-weight: 700;
                z-index: 1;
            }
        }

        button{
            width: 40px;
            height: 40px;
            background: #efefef;
            border: none;

            .iconFigure{
                width: 24px;
            }
        }
    `,
}